import type { SvgProps } from "replo-utils/react/components";

import React from "react";

import { Svg } from "replo-utils/react/components";

function SvgGapModifier(props: SvgProps) {
  return (
    <Svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 9.5H9C8.5 9.5 8 9 8 8.5V3.5C8 3 8.5 2.5 9 2.5H10.5M1.5 2.5H3C3.5 2.5 4 3 4 3.5V6V8.5C4 9 3.5 9.5 3 9.5H1.5M6 4V8"
        stroke="#64748B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default SvgGapModifier;
